module.exports = __webpack_public_path__ + "media/images/mobile/Slider4-e2501989309eff932bbd2b885ed5adff.png";